import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { getValueOption, valueOption } from '../../../store/selectors/selectors';
import { dependencySettingT } from '../../../utils/type/dynamic-rendering.interfaces';
import { Hint } from '../../Hint/Hint';
//@ts-ignore
import s from './LineParams.module.scss';

export type inputComponentsAdditionalProperties = {
    maxWidth?: string;
    fontWidth?: number;
    groupGap?: boolean;
    gap?: string;
    backgroundColor?: string;
    padding?: string;
    margin?: string;
}
export type LineParamsT = {
    label: string,
    id: string,
    isRequired: boolean,
    additionalProperties?: inputComponentsAdditionalProperties
    dependencySettings?: dependencySettingT[]
    hint?: any
    children?: any,
    [key: string]: unknown
}

export const LineParam = ({ ...props }: LineParamsT) => {
    let { children, label, isRequired, additionalProperties, hint, dependencySettings, id, parentKeySection } = props;
    let style: any = {
        maxWidth: !!additionalProperties ? additionalProperties['maxWidth'] : `auto`,
        width: !!additionalProperties ? `100%` : `auto`,
    };
    if (additionalProperties && additionalProperties['groupGap']) {
        style = {
            ...style,
            display: 'grid',
            gap: '15px',
        }
    }

    const styleTitle: any = {
        fontWidth: (!!additionalProperties && additionalProperties['fontWidth']) ? `${additionalProperties['fontWidth']}` : '400'
    };


    let styleWrap: any = {}
    if (additionalProperties && additionalProperties['margin']) {
        styleWrap = {
            ...styleWrap,
            margin: additionalProperties['margin'],
        }
    }

    const [isShowError, setIsShowError] = useState(false)
    let classErrorText = `${s.errorText} `;
    if (isShowError) classErrorText += `${s.show}`;

    let { selectValue, isError }: valueOption = useSelector(state => getValueOption({ idOptions: id, parentKeySection })(state));



    return (
        <div className={s.lineParams} style={styleWrap} >
            <div className={s.lineParamsTitle} style={styleTitle}>
                <div className={s.wrapName}>
                    <div className={s.name}>{label} {isRequired && (<span>*</span>)}</div>
                    {isError && (<div className={s.shortError}
                        onMouseEnter={() => setIsShowError(true)}
                        onMouseLeave={() => setIsShowError(false)}
                    >There is no availability for zip code 955</div>)}

                </div>
                {isError && (<div className={s.error}>
                    <div className={classErrorText}>There is no availability for zip code 955</div>
                </div>)}
                {hint && <Hint  >
                    <div className={s.boxHint}>
                        <div className={s.text}>{hint}</div>
                    </div>
                </Hint>}

            </div>
            <div className={s.lineParamsComponent} style={style}>{children}</div>
        </div>
    )
}


